@if (showRadioButtons) {
    <div class="agpr-formField">
        @if (field.label) {
            <div
                class="agpr-formField-label agpr-radioButtonContainer-heading"
                [ngClass]="field.headingStyleClass"
            >
                {{ field.label | localize }}
            </div>
        }

        @if (field.inSectionLabel) {
            <div
                class="agpr-formField-label"
                [ngClass]="field.headingStyleClass"
            >
                {{ field.inSectionLabel | localize }}
            </div>
        }
        <div>
            <ng-container *ngFor="let fieldOption of field.options; let i = index">
                <div
                    class="agpr-radioButtonContainer"
                    role="radiogroup"
                    [attr.aria-labelledby]="field.headingId"
                >
                    <agpr-radio
                        name="chart-radio-button-{{field.property}}"
                        [id]="id + '.radio-buttons_' + i"
                        [value]="fieldOption.key"
                        [label]="fieldOption.label"
                        [hiddenLabel]="fieldOption.label"
                        [tooltip]="fieldOption.tooltip"
                        [disabled]="fieldOption.disabled"
                        [(ngModel)]="selectedOption"
                        (ngModelChange)="onRadioButtonChanged(fieldOption)"
                    ></agpr-radio>

                    <ng-container *ngFor="let fieldSubOption of fieldOption.subRadioOptions; let i = index">
                        <div
                            *ngIf="selectedOption === fieldOption.key"
                            class="agpr-radioButton-subRadioContainer"
                        >
                            <agpr-radio
                                *ngIf="fieldSubOption.displayRadioButton"
                                name="chart-subRadio-button-{{field.property}}"
                                [id]="id + '.subRadio-buttons_' + i"
                                [value]="fieldSubOption.key"
                                [label]="fieldSubOption.label"
                                [hiddenLabel]="fieldSubOption.label"
                                [tooltip]="fieldSubOption.tooltip"
                                [disabled]="fieldSubOption.disabled"
                                [(ngModel)]="selectedSubOption"
                                (ngModelChange)="onRadioButtonChanged()"
                            ></agpr-radio>
                            <ng-container *ngFor="let colorField of fieldSubOption.colorOptions">
                                <div
                                    *ngIf="selectedSubOption === fieldSubOption.key"
                                    class="agpr-radioButton-colorFieldContainer"
                                >
                                    <agpr-color-picker-field
                                        *ngIf="!useChartPrefColors"
                                        class="agpr-radioButton-colorField"
                                        [field]="colorField"
                                        [block]="block"
                                        (changes)="onRadioButtonChanged()"
                                    >
                                    </agpr-color-picker-field>
                                    <agpr-chart-color-picker-field
                                        *ngIf="useChartPrefColors"
                                        class="agpr-radioButton-colorField"
                                        [field]="colorField"
                                        [block]="block"
                                        (changes)="onRadioButtonChanged()"
                                    >
                                    </agpr-chart-color-picker-field>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
}
